import './EditItems.css';
import Button from './Button';
import CancelButton from './CancelButton';
import {useState} from 'react';

function EditItems(props) {

    const [itemName, setItemName] = useState(props.name);
    const [itemPrice, setItemPrice] = useState(props.price.toFixed(2));
    const [itemCategory, setItemCategory] = useState('Set Category')
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [itemMealPrice, setItemMealPrice] = useState(props.mealprice ? props.mealprice.toFixed(2) : 0.00);


    return (
        <div className='main-edit-item-div'>
            <div className='edit-fields'>
                <span className='edit-span'>Name:</span>
                <input className='edit-name edit-item-field' value={itemName} onChange={(e) => setItemName(e.target.value)} />
                <span className='edit-span'>Price:</span>
                <input className='edit-price edit-item-field' type="number" min="0.00" max="10000.00" step="0.01" value={itemPrice} onChange={(e) => setItemPrice(e.target.value)}/>
                {
                    props.category === 'entree' || itemCategory === 'Entree' ? <span className='edit-span'>Meal Price:</span> : null
                }
                {
                    props.category === 'entree' || itemCategory === 'Entree' ? 
                        <input className='edit-price edit-item-field' type='number' min='0.00' max='10000.00' step='0.01' value={itemMealPrice} onChange={e => setItemMealPrice(e.target.value)} /> : null
                }
                {
                    props.new ? <div className='category-dropdown-div'>
                        <button className='category-dropdown' onClick={() => setDropdownOpen(!dropdownOpen)}>{itemCategory}</button>
                        {
                            dropdownOpen ? <ul className='dropdown-open-div'>
                                <li className='dropdown-item' onClick={() => {setItemCategory('Entree'); setDropdownOpen(!dropdownOpen)}}>Entree</li>
                                <li className='dropdown-item' onClick={() => {setItemCategory('Side'); setDropdownOpen(!dropdownOpen)}}>Side</li>
                                <li className='dropdown-item' onClick={() => {setItemCategory('Extra'); setDropdownOpen(!dropdownOpen)}}>Extra</li>
                            </ul> : null
                        }
                    </div> : null
                }
            </div>
            <div className='edit-buttons'>
                {
                    props.new ? <div className='edit-buttons'>
                        <Button buttonText='Save' onClickFunction={() => props.addItem(itemName, itemPrice, itemMealPrice, itemCategory.toLowerCase())}/>
                        <CancelButton buttonText='Cancel' onClickFunction={() => props.cancelItem()}/>
                    </div> : <div className='edit-buttons'>
                    <Button buttonText='Save Changes' onClickFunction={() => props.editItem(props.id, itemName, itemPrice, itemMealPrice, props.category)}/>
                    <CancelButton buttonText='Delete' onClickFunction={() => props.deleteItem(props.id, itemName, itemPrice, props.category)}/>
                    </div>
                }
            </div>
        </div>
    )
}

export default EditItems;